export default __webpack_public_path__ + "static/media/polygon-filled.7c7ea879.png";